import styled from "styled-components";

export const LogoUpperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1rem auto 2rem auto;

  > p {
    color: ${(props) => props.theme.palette.common.text.primary};
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0px;
    margin-left: 1.5rem;
    @media (max-width: 600px) {
      font-size: 1.2rem;
    }
  }

  > h3 {
    color: ${(props) => props.theme.palette.common.text.primary};
    font-weight: 650;
  }
`;

export const LogoWrap = styled.div`
  width: 7.5rem;
  height: 7.5rem;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${({ theme, small }) =>
    theme.palette.card.background.primary};
  position: relative;

  img {
    margin-top: 0.25rem;
    width: 7rem;
    height: 7rem;
    border-radius: 50%;
    align-self: center;
  }

  @media (max-width: 600px) {
    width: 7rem;
    height: 7rem;
  }
`;
